import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import DeafCampPage1 from "../Components/DeafCampPage1";
import DeafCampPage2 from "../Components/DeafCampPage2";
import DeafCampPage3 from "../Components/DeafCampPage3";
import {Helmet} from "react-helmet";

function CampsDeaf() {
   return (
      <div>
         <Helmet>
            <title>Deaf Camp - Camp Connect</title>
         </Helmet>
         <div className='juniorNavbar'>
            <Navbar />
         </div>
         <DeafCampPage1/>
         <DeafCampPage2/>
         <DeafCampPage3/>
         <Footer/>
      </div>
   )
};

export default CampsDeaf;
